// extracted by mini-css-extract-plugin
export default {"content":"animated-module--content--B+2tb","moveX":"animated-module--moveX--IW0U8","moveY":"animated-module--moveY--vDHrD"};